import { render } from "./SupplierItem.vue?vue&type=template&id=5cc56368&scoped=true"
import script from "./SupplierItem.vue?vue&type=script&lang=js"
export * from "./SupplierItem.vue?vue&type=script&lang=js"

import "./SupplierItem.vue?vue&type=style&index=0&id=5cc56368&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc56368"]])

export default __exports__